<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Basic Settings {{$G_DEVICE_CFG.isWlBandSteering ? '' : '2.4GHz'}}</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item :label="$G_DEVICE_CFG.isWlBandSteering ? 'Enable WLAN' : 'Enable WLAN 2.4GHz:'">
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-switch v-model="wl1Enable" @change="setWlEnabelData" 
                :disabled="$G_DEVICE_CFG.isFindSubRouter"></el-switch>
                </el-tooltip>
            </el-form-item>
            <div v-if="wl1Enable">
                <el-form-item label="Choose SSID :" v-if="!$G_DEVICE_CFG.isWlBandSteering">
                    <el-select v-model="wlform.ssidIndex" style="width: 100%" placeholder="Please select SSID" @change="chooseSSID">
                        <el-option label="SSID1" value="0"></el-option>
                        <el-option label="SSID2" value="1" :disabled="$isTRUE"></el-option>
                        <el-option label="SSID3" value="2" :disabled="$isTRUE"></el-option>
                        <el-option label="SSID4" value="3" :disabled="$isTRUE"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Enable SSID :" >
                    <el-switch v-model="wlform.enable"></el-switch>
                </el-form-item>
                <el-form-item label="Enable Isolation :">
                    <el-switch v-model="wlform.Isolation"></el-switch>
                </el-form-item>
                <el-form-item label="Hide SSID :">
                    <el-switch v-model="wlform.hiddenSSID"></el-switch>
                </el-form-item>
                <el-form-item label="SSID :" prop="ssid">
                    <el-input v-model.trim="wlform.ssid"></el-input>
                </el-form-item>
                <el-form-item label="BSSID :">
                    <span class="fhv-form-itme">{{wlform.macAddr}}</span>
                </el-form-item>
                <el-form-item label="Country :">
                    <el-tooltip content="Please modify the country code carefully" placement="bottom" effect="light">
                    <el-select v-model="wlform.country" filterable placeholder="Please select country" :disabled="!isTOT">
                        <el-option  v-for="item in wlCountry"
                            :key="item.val" 
                            :label="item.countryName"
                            :value="item.val"
                        ></el-option>
                    </el-select>
                    </el-tooltip>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="apply">Apply</el-button>
                    <el-button type="primary" @click="refresh">Refresh</el-button>
                </el-form-item>
             </div>
        </el-form>
    </div>
    
</template>

<script>
import devConfig from '@/devConfig'
import sizeof from '@/util/jsCharLength.js'
import wlCountryDef from '@/util/wlanCountryDef.js'

export default {
    data(){
       return {
           getLoad:false,
           wl1Enable:true,
           isTOT:false,
           wlform:{
               enable:true,
               hiddenSSID:false,
               Isolation:false,
               macAddr:"",
               ssid:"",
               ssidIndex:"0",
               country:"UNITED STATES"
           },
           wlCountry: [],
           formCheck:{
               ssid:[
                    { required: true, message: 'Please enter SSID name', trigger: 'blur' },
                    { 
                        validator:(rule, value, callback) => {
                            if(sizeof(value,'utf-8') > 32 || sizeof(value,'utf-8') < 1)
                                callback(new Error("SSID name cannot be longer than 32 byte"))
                            else
                                callback()
                        },
                        trigger: 'blur' 
                    }
                ],
           } 
       }
    },
    created(){
        devConfig.init(this,()=>{
            this.getBasicData()
            this.isTOT =devConfig.getData().area === 'TOT'
        })
       
    },
    methods:{
        setWlEnabelData(data){
            const loadingInstance = this.$loading({lock: true})
            axios
            .post("/JSONAPI",{
                cmdType:"HOME_SET_WLAN_ENABLE",
                wlEnable:this.wl1Enable,
                wlIndex:1
            })
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },3000)
            })

        },
        getBasicData(){
            this.getLoad = true
            this.wlCountry = wlCountryDef
            axios
            .post("/boafrm/fhBasicWlan",{
                CmdType:"GET_BASE_WLAN",
                ssidIndex:this.wlform.ssidIndex
            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wlform.enable = response.data.enable
                    if(this.wlform.ssidIndex === '0')
                        this.wl1Enable = response.data.allEnable
                    this.wlform.hiddenSSID = response.data.hiddenSSID
                    this.wlform.Isolation = response.data.Isolation
                    this.wlform.macAddr = response.data.macAddr
                    this.wlform.ssid = response.data.ssid
                    this.wlform.country = wlCountryDef[response.data.country].countryName || 'THAILAND'
                }
            })
        },
        setBasicData(){
            const loadingInstance = this.$loading({lock: true})
            axios
            .post("/boafrm/fhBasicWlan",{
                CmdType:"SET_BASE_WLAN",
                ssidIndex:this.wlform.ssidIndex,
                allEnable:this.wl1Enable,
                enable:this.wlform.enable,
                hiddenSSID:this.wlform.hiddenSSID,
                Isolation:this.wlform.Isolation,
                ssid:this.wlform.ssid,
                country:this.wlform.country,
            })
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(response.data.ret == '0')
                        this.$message.success("Configuration is successful!")
                    else
                        this.$message.error("Configuration failed!")
                },3000)
            })
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setBasicData()
                } else {
                    return false;
                }
            })
        },
        refresh(){
            this.$refs['wlform'].resetFields();
            this.getBasicData()
        },
        chooseSSID(){
            this.$refs['wlform'].resetFields();
            this.getBasicData()
        }
    },
}
</script>





